import script from "./ContactInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ContactInfo.vue?vue&type=style&index=0&id=d422d64c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d422d64c"]])

export default __exports__